let baseURL = process.env.VUE_APP_baseURL;
let jumpWeb = process.env.VUE_APP_fileURL;
let fileURL = process.env.VUE_APP_jumpWeb;
let testURL = process.env.VUE_APP_testURL;
let testApiURL = process.env.VUE_APP_testApiURL;
let sysId = process.env.VUE_APP_sysId;
let leafletApiURL = process.env.VUE_APP_leafletApiURL;
let leafletSysId = process.env.VUE_APP_leafletSysId;
let videourl = process.env.VUE_APP_videourl;
let webUrl = process.env.VUE_APP_webUrl;
let salt = "read-crtvup*123.cv987@"; //征订md5加密盐值
let publicKey = process.env.VUE_APP_publicKey; //征订token加密私钥
let robotBook = [
  "1694952726309507072",
  "1674758026424356864",
  "1686915284222480384",
  "1613418196050776064",
  "1715350359456747520",
  "1689873142887092224",
  "1714910845827420160",
  "1714911020151083008",
  "1714915177180303360",
  "1714915363659059200",
  "1714915523055194112",
  "1714915696862957568",
  "1714915891730321408",
  "1714916095212785664",
  "1714916282954027008",
  "1734864214557855744",
];
module.exports = {
  baseURL,
  jumpWeb,
  fileURL,
  testURL,
  testApiURL,
  sysId,
  leafletApiURL,
  leafletSysId,
  salt,
  videourl,
  robotBook,
  webUrl,
  publicKey
};
